import script from "./clientmenu.vue?vue&type=script&setup=true&lang=js"
export * from "./clientmenu.vue?vue&type=script&setup=true&lang=js"

import "./clientmenu.vue?vue&type=style&index=0&id=c1ef72d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1ef72d8"]])

export default __exports__